import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Header from './header';
import Content from './content';
import BottomFooter from './footer';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { search, content, footer, columnMap },
        } = this.props;

        return (
            <React.Fragment>
                <Header content={search} />
                <main className={styles.main}>
                    <Content content={content} columnMap={columnMap} />
                </main>
                <BottomFooter content={footer} />
                <ChipEdit transform={transform} />
            </React.Fragment>
        );
    }
}

export default errorBoundary(Layout);
